import { render, staticRenderFns } from "./cerfatva.vue?vue&type=template&id=0dbaeda0&scoped=true&"
import script from "./cerfatva.vue?vue&type=script&lang=js&"
export * from "./cerfatva.vue?vue&type=script&lang=js&"
import style0 from "./cerfatva.vue?vue&type=style&index=0&id=0dbaeda0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbaeda0",
  null
  
)

export default component.exports